import { ReactNode } from 'react';
import { ArrowCircleRightIcon } from '@heroicons/react/solid';

import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class FolderMoveHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser) {
    super(history, user);
    this.action = 'moved';
  }

  detailText(): ReactNode {
    if (this.history.attributes?.migrated) {
      return this.history.attributes?.migrated.description;
    } else {
      const changes = this.history.attributes?.changes;
      return (
        <div data-testid="history-detail-text">
          The folder{' '}
          <span className="font-semibold break-all">{this.history.attributes?.next.name}</span> was{' '}
          moved from <span className="font-semibold break-all">{changes.prevParent}</span> to{' '}
          <span className="font-semibold break-all">{changes.nextParent}</span>.
        </div>
      );
    }
  }

  detailIcon(): ReactNode {
    return <ArrowCircleRightIcon className="h-5 fill-support-info" />;
  }
}
